module.exports = __webpack_public_path__ + "img/18.96a1edd1.png";